import React from "react";
const Error = ({ mensaje }) => {
  return <p className=" error red darken-3">{mensaje}</p>;
};

export default Error;
